import React, { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
const Confirmation = (props) => {

    const [remark, setRemark] = useState();
    const [formData, setFormData] = useState({})
    const remarkData = (e) => {
        const { name, value } = e.target;
        setRemark((prevData) => ({ ...prevData, [name]: value }));
    }
    const onSave = (e) => {
        e.preventDefault();
        props.onSave({remark:remark,formData:formData})
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      
      };
    return (
      <>
       <Modal  {...props}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className='circle-confirm '>
        <div className="confirmation-circle"></div>
        </div>
        {props.modalId === 'statusChangeMerchant' && (
    
             <>
                <p>
                Are you sure you want to {props.status === 'Active' ? 'Suspend' : 'Activate'} Merchant ?
                 </p>
                <div className="form-group frm" style={{textAlign: 'left'}}>
                <label htmlFor="confirm_password">REMARK</label>
                <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
                </div>
            </>
        )}

{props.modalId === 'statusChangeAutoPay' && (
    
    <>
       <p>
       Are you sure you want to {props.auto_pay === true ? 'disable' : 'enable'} autopay ?
        </p>
       {/* <div className="form-group frm" style={{textAlign: 'left'}}>
       <label htmlFor="confirm_password">REMARK</label>
       <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
       </div> */}
   </>
)}

{props.modalId === 'statusChangeAutoPaySuspend' && (
    
    <>
       <p>
       Are you sure you want to disable autopay for all agents ?
        </p>
       {/* <div className="form-group frm" style={{textAlign: 'left'}}>
       <label htmlFor="confirm_password">REMARK</label>
       <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
       </div> */}
   </>
)}

{props.modalId === 'statusChangeAutoPayResume' && (
    
    <>
       <p>
       Are you sure you want to enable autopay for all agents ?
        </p>
       {/* <div className="form-group frm" style={{textAlign: 'left'}}>
       <label htmlFor="confirm_password">REMARK</label>
       <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
       </div> */}
   </>
)}

{props.modalId === 'statusChangeDistributor' && (
    
    <>
       <p>
       Are you sure you want to {props.status === 'Active' ? 'Suspend' : 'Activate'} Distributor ?
        </p>
       <div className="form-group frm" style={{textAlign: 'left'}}>
       <label htmlFor="confirm_password">REMARK</label>
       <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
       </div>
   </>
)}

{props.modalId === 'statusChangeUser' && (
    <>
        <p>
            Are you sure you want to {props.status === 'Active' ? 'Suspend' : 'Activate'} User ?
        </p>
              <div className="form-group frm" style={{textAlign: 'left'}}>
              <label htmlFor="confirm_password">REMARK</label>
              <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
              </div>
              </>
        )}

        {props.modalId === 'statusChangeAgent' && (
            <>
        <p>
            Are you sure you want to {props.status === 'Active' ? 'Suspend' : 'Activate'} Agent ?
        </p>
              <div className="form-group frm" style={{textAlign: 'left'}}>
              <label htmlFor="confirm_password">REMARK</label>
              <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
              </div>
              </>
  
        )}

  {props.modalId === 'statusChangeAgentSuspend' && (
    <>
          <p>
              Are you sure you want to Suspend Agent ?
          </p>
           <div className="form-group frm" style={{textAlign: 'left'}}>
           <label htmlFor="confirm_password">REMARK</label>
           <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
           </div>
           </>
          )}

{props.modalId === 'statusChangeUserSuspend' && (
    <>
          <p>
              Are you sure you want to Suspend User ?
          </p>
           <div className="form-group frm" style={{textAlign: 'left'}}>
           <label htmlFor="confirm_password">REMARK</label>
           <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
           </div>
           </>
          )}

{props.modalId === 'statusChangeUserResume' && (
    <>
          <p>
              Are you sure you want to Activate User ?
          </p>
               <div className="form-group frm" style={{textAlign: 'left'}}>
               <label htmlFor="confirm_password">REMARK</label>
               <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
               </div>
               </>
          )}
          

  {props.modalId === 'statusChangeAgentResume' && (
    <>
          <p>
              Are you sure you want to Activate Agent ?
          </p>
              <div className="form-group frm" style={{textAlign: 'left'}}>
              <label htmlFor="confirm_password">REMARK</label>
              <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
              </div>
              </>
          )}

{props.modalId === 'statusChangeMerchantSuspend' && (
    <>
          <p>
              Are you sure you want to Suspend Merchant ?
          </p>
          <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="confirm_password">REMARK</label>
          <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
          </div>
          </>
          )}

  {props.modalId === 'statusChangeMerchantResume' && (
    <>
          <p>
              Are you sure you want to Activate Merchant ?
          </p>
          <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="confirm_password">REMARK</label>
          <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
          </div>
          </>
          )}

{props.modalId === 'statusChangeLimitSuspend' && (
    <>
          <p>
              Are you sure you want to Suspend Limits ?
          </p>
          <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="confirm_password">REMARK</label>
          <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
          </div>
          </>
          )}

  {props.modalId === 'statusChangeLimitResume' && (
    <>
          <p>
              Are you sure you want to Activate Limits ?
          </p>
          <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="confirm_password">REMARK</label>
          <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
          </div>
          </>
          )}

{props.modalId === 'statusChangeCommisonSuspend' && (
    <>
          <p>
              Are you sure you want to Suspend Commissions ?
          </p>
          <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="confirm_password">REMARK</label>
          <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
          </div>
          </>
          )}

  {props.modalId === 'statusChangeCommisionLimitResume' && (
    <>
          <p>
              Are you sure you want to Activate Commissions ?
          </p>
          <div className="form-group frm" style={{textAlign: 'left'}}>
          <label htmlFor="confirm_password">REMARK</label>
          <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
          </div>
          </>
          )}
        
        {props.modalId === 'statusChangeAgentLimit' && (
            <>
        <p>
            Are you sure you want to {props.status === 'Active' ? 'Suspend' : 'Activate'} Agent Limit?
        </p>
        <div className="form-group frm" style={{textAlign: 'left'}}>
        <label htmlFor="confirm_password">REMARK</label>
        <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
        </div>
        </>
        )}

        {props.modalId === 'statusChangeAgentCommission' && (
            <>
        <p>
            Are you sure you want to {props.status === 'Active' ? 'Suspend' : 'Activate'} Agent Commission?
        </p>
        <div className="form-group frm" style={{textAlign: 'left'}}>
        <label htmlFor="confirm_password">REMARK</label>
        <input type="text" className="form-control nhjgf" id="profile_conpass" placeholder="Enter Remark" onChange={remarkData} name ="remark"/>
        </div>
        </>
        )}



        {props.modalId === 'deleteMerchant' && (
        <p>
            Are you sure you want to delete Merchant?
        </p>
        )}
        {props.modalId === 'deleteDistributor' && (
        <p>
            Are you sure you want to delete Distributor?
        </p>
        )}

        {props.modalId === 'deleteAgent' && (
        <p>
            Are you sure you want to delete Agent?
        </p>
        )}

{props.modalId === 'deleteUser' && (
        <p>
            Are you sure you want to delete Agent?
        </p>
        )}

        {props.modalId === 'deleteAgentLimit' && (
        <p>
            Are you sure you want to delete Agent Limit?
        </p>
        )}

        {props.modalId === 'deleteAgentCommission' && (
        <p>
            Are you sure you want to delete Agent Commission?
        </p>
)}

        {props.modalId === 'statusChangeBankingPartner' && (
        <p>
            Are you sure you want to {props.status === 'Active' ? 'Deactivate' : 'Activate'} {props.partner_name}?
        </p>
        )}

        {props.modalId === 'deleteBankingPartner' && (
        <p>
            Are you sure you want to delete {props.partner_name}? This action cannot be undone.
        </p>
        )}

        {props.modalId === 'deletePayment' && (
              <p>
                  Are you sure you want to delete Wallet?
              </p>

        )}

      {props.modalId === 'statusChangePayment' && (
        <p>
            Are you sure you want to {props.status === 'A' ? 'Suspended' : 'Activate'} payment Method ?
        </p>
        )}

{props.modalId === 'statusChangeWeb' && (
        <p>
            Are you sure you want to {props.status === 'A' ? 'Suspended' : 'Activate'} webhooks ?
        </p>
        )}



        
      {props.modalId === 'commsionRange' && (
        <p>
           Some of the fields are not saved, Are you sure you want to proceed ?
        </p>
        )}
{props.modalId === 'updateTransaction' && (
    <>
          <p>
          Are you sure you want to {props.status === 'approve' ? 'approve' : 'reject'} transaction ?
          </p>

          <div className="form-group" style={{'marginBottom':0}}>
          <label htmlFor="Transaction">UTR/RRN</label>
              <input
                type="text"
                className='form-control'
                id="email"
                placeholder="Enter UTR"
                value={formData.utr}
                onChange={handleChange}
                name="utr"
              
              />
       
            </div>

            
          <div className="form-group" style={{'marginBottom':0}}>
          <label htmlFor="Transaction">Adjust Amount</label>
              <input
                type="number"
              
                 className='form-control'
                id="email"
                placeholder="Enter Amount"
                value={formData.amount}
                onChange={handleChange}
                name="amount"
              
              />
       
            </div>
       
            <div className="form-group">
          <label htmlFor="Transaction">Remarks</label>
              <textarea
                type="textarea"
                 className='form-control'
                id="email"
                placeholder="Enter Remarks"
                value={formData.remarks}
                onChange={handleChange}
                name="remarks"
              
              />
       
            </div>
       
              </>
          )}

            
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light border" onClick={props.onHide}>
            Close
          </Button>
          <Button variant="" onClick={onSave} className='btn-bg-theme-Color'>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      </>
    );
  }
  


  export default Confirmation;



